import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10aad2d6")

_pushScopeId("data-v-10aad2d6")
const _hoisted_1 = { class: "AdditionalServices__header" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h2", { class: "header__title" }, "Дополнительные услуги"),
  /*#__PURE__*/_createVNode("p", null, "(не обязательно)")
], -1)
const _hoisted_3 = { class: "AdditionalServices__body" }
const _hoisted_4 = {
  key: 0,
  class: "AdditionalServices__footer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", {
    class: ["AdditionalServices", { AdditionalServicesFTL: _ctx.isFTL }]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.closable)
        ? (_openBlock(), _createBlock(_component_icon_close, {
            key: 0,
            class: "header__cancel",
            onClick: _ctx.emitClose
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_3, [
      (!_ctx.setted)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_s_checkbox, {
              theme: _ctx.themeClass,
              label: "Авто",
              value: _ctx.state.hasCar,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.hasCar = $event))
            }, null, 8, ["theme", "value"]),
            _createVNode(_component_s_checkbox, {
              theme: _ctx.themeClass,
              label: "Мягкая упаковка",
              value: _ctx.state.hasSoftPackage,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.hasSoftPackage = $event))
            }, null, 8, ["theme", "value"]),
            _createVNode(_component_s_checkbox, {
              theme: _ctx.themeClass,
              label: "Манипулятор",
              value: _ctx.state.hasManipulator,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.hasManipulator = $event))
            }, null, 8, ["theme", "value"]),
            _createVNode(_component_s_checkbox, {
              theme: _ctx.themeClass,
              label: "Кран",
              value: _ctx.state.hasCrane,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.hasCrane = $event))
            }, null, 8, ["theme", "value"]),
            _createVNode(_component_s_checkbox, {
              theme: _ctx.themeClass,
              label: "Рохля",
              value: _ctx.state.hasHydraulicTrolley,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.hasHydraulicTrolley = $event))
            }, null, 8, ["theme", "value"]),
            _createVNode(_component_s_checkbox, {
              theme: _ctx.themeClass,
              label: "Обрешетка",
              value: _ctx.state.hasGrid,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.hasGrid = $event))
            }, null, 8, ["theme", "value"]),
            _createVNode(_component_s_checkbox, {
              theme: _ctx.themeClass,
              label: "Грузчики",
              value: _ctx.state.hasLoader,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.hasLoader = $event))
            }, null, 8, ["theme", "value"]),
            _createVNode(_component_s_checkbox, {
              theme: _ctx.themeClass,
              label: "Паллета",
              value: _ctx.state.hasPallet,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.hasPallet = $event))
            }, null, 8, ["theme", "value"])
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("span", null, "Авто: " + _toDisplayString(_ctx.state.hasCar ? 'Да' : 'Нет'), 1),
            _createVNode("span", null, "Мягкая упаковка: " + _toDisplayString(_ctx.state.hasSoftPackage ? 'Да' : 'Нет'), 1),
            _createVNode("span", null, "Манипулятор: " + _toDisplayString(_ctx.state.hasManipulator ? 'Да' : 'Нет'), 1),
            _createVNode("span", null, "Кран: " + _toDisplayString(_ctx.state.hasCrane ? 'Да' : 'Нет'), 1),
            _createVNode("span", null, "Рохля: " + _toDisplayString(_ctx.state.hasHydraulicTrolley ? 'Да' : 'Нет'), 1),
            _createVNode("span", null, "Обрешетка: " + _toDisplayString(_ctx.state.hasGrid ? 'Да' : 'Нет'), 1),
            _createVNode("span", null, "Грузчики: " + _toDisplayString(_ctx.state.hasLoader ? 'Да' : 'Нет'), 1),
            _createVNode("span", null, "Паллета: " + _toDisplayString(_ctx.state.hasPallet ? 'Да' : 'Нет'), 1)
          ], 64))
    ]),
    (!_ctx.setted)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_s_button, {
            class: { 'red small text': _ctx.isFTL, primary: _ctx.isLTL },
            onClick: _ctx.emitContinue
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.isFTL ? 'Подтвердить' : 'Продолжить'), 1)
            ]),
            _: 1
          }, 8, ["class", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
})